import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../../../../../app/store';
import PublicacaoOficialPublicListFiltroForm from './PublicacaoOficialPublicListFiltroForm';

import errorFormat from '../../../../../utils/errorFormat';
import { useGetPublicacoesOficiaisPublicQuery, useLazyGetPublicacoesOficiaisPublicQuery } from '../publicaoOficialAnexoApiSlice';
import { PublicacaoOficialList } from '../types/PublicacaoOficial';
import PublicacaoOficialPublicCardForm from './PublicacaoOficialPublicCardForm';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { IStipoPublicacaoOficial, TipoPublicacaoOficial } from '../../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';
import { useGetTipoPublicacaoOficialByNomeQuery } from '../../tipoPublicacaoOficial/tipoPublicacaoOficialApiSlice';
import { atualizarPublicacaoOficialTipo } from './publicacaoOficialPublicListFiltroSlice';

export function PublicacaoOficialPublicList() {
  const [plublicacoesOficiais, setplublicacoesOficiais] = useState<PublicacaoOficialList[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);

  const loaderRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const filtro = useSelector((state: RootState) => state.publicacaoOficialPublicListFiltro);

  const theme = useTheme();

  const [tipoPublicacaoOficialSelecionado, setTipoPublicacaoOficialSelecionado] = useState<TipoPublicacaoOficial>(IStipoPublicacaoOficial);
  const paramTipo = useParams().tipo || null;
  const dispatch = useDispatch();

  const {
    data: dataTipoPublicacaoOficial,
    isFetching: isFetchingTipoPublicacaoOficial,
    error: errorTipoPublicacaoOficial
  } = useGetTipoPublicacaoOficialByNomeQuery(paramTipo || '', { skip: !paramTipo });
  
  /*
  useEffect(() => {
    if (dataTipoPublicacaoOficial) {
      setTipoPublicacaoOficialSelecionado(dataTipoPublicacaoOficial);
      dispatch(atualizarPublicacaoOficialTipo(dataTipoPublicacaoOficial));
      console.log('esta carregando', dataTipoPublicacaoOficial);
    }
  }, [dataTipoPublicacaoOficial, errorTipoPublicacaoOficial, isFetchingTipoPublicacaoOficial]);
*/
  // RTK Query
  // const { data, isFetching, isLoading, error } = useGetPublicacoesOficiaisPublicQuery({
  //  data_inicial: filtro.dataInicial,
  //  data_final: filtro.dataFinal,
  //  search: filtro.search,
  //  page,
  //  apply: filtro.apply
  //});

  const [triggerGetPublicacoes, { data, isFetching, isLoading, error }] = useLazyGetPublicacoesOficiaisPublicQuery();
/*
  
  useEffect(() => {
    triggerGetPublicacoes({
      data_inicial: filtro.dataInicial,
      data_final: filtro.dataFinal,
      search: filtro.search,
      page: 1,
      apply: false,
      tipo: dataTipoPublicacaoOficial?.id || 'bruno' //aqui nao esta pegando o id, mas ele esta sendo carregado la em cima
    });
  }, []);
  */

useEffect(() => {
  // Monta o objeto base sem tipo
  const payload: any = {
    data_inicial: filtro.dataInicial,
    data_final: filtro.dataFinal,
    search: filtro.search,
    page: 1,
    apply: false
  };

  // Se o tipo existir, adiciona ao payload
  if (dataTipoPublicacaoOficial?.id) {
     setTipoPublicacaoOficialSelecionado(dataTipoPublicacaoOficial);
      dispatch(atualizarPublicacaoOficialTipo(dataTipoPublicacaoOficial));
      //console.log('esta carregando', dataTipoPublicacaoOficial);
    payload.tipo = dataTipoPublicacaoOficial.id;
  }

  // Dispara a busca com ou sem tipo
  triggerGetPublicacoes(payload);
}, [dataTipoPublicacaoOficial]);





  const handleBuscar = async () => {
    try {
      setInitialLoading(true);
      setPage(1);
      const result = await triggerGetPublicacoes({
        data_inicial: filtro.dataInicial,
        data_final: filtro.dataFinal,
        search: filtro.search,
        page: 1,
        apply: filtro.apply,
        exercicio: filtro.exercicio,
        tipo: filtro.tipo?.id || null
      }).unwrap();

      setplublicacoesOficiais(result.results || []);
      setHasMore(Boolean(result.next));
    } catch (err) {
      const erroReturn: string = errorFormat(err as FetchBaseQueryError);
      enqueueSnackbar('Erro ao carregar as notícias.', { variant: 'error' });
      enqueueSnackbar(erroReturn, { variant: 'error' });
      console.error(err);
    } finally {
      setInitialLoading(false);
    }
  };

  // Atualiza estado com os dados retornados
  useEffect(() => {
    if (!data) {
      setInitialLoading(false); // garante que nunca fique travado
      return;
    }

    if (page === 1) {
      setplublicacoesOficiais(data.results);
    } else {
      setplublicacoesOficiais(prev => [...prev, ...data.results]);
    }

    setHasMore(Boolean(data.next));
    setInitialLoading(false);
  }, [data, page]);

  // Erro ao carregar
  useEffect(() => {
    if (error) {
      enqueueSnackbar('Erro ao carregar as notícias.', { variant: 'error' });
      const erroReturn: string = errorFormat(error);
      enqueueSnackbar(erroReturn, { variant: 'error' });
      console.log(error);
    }
  }, [error, enqueueSnackbar]);

  // Reset ao mudar filtros
  useEffect(() => {
    setplublicacoesOficiais([]);
    setPage(1);
    setHasMore(true);
    setInitialLoading(true);
  }, [filtro.apply]);

  // Scroll infinito
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && hasMore && !isFetching && !initialLoading) {
          setPage(prev => prev + 1);
        }
      },
      { rootMargin: '200px' }
    );

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [hasMore, isFetching, initialLoading]);

  // Restaura a página salva para carregar as notícias corretas
  useEffect(() => {
    const scrollData = localStorage.getItem('scrollPublicacao');
    if (!scrollData) return;

    const { page: savedPage } = JSON.parse(scrollData);
    if (savedPage) {
      setPage(savedPage);
    }
  }, []);

  // Scroll restore com limite de tentativas e cancelamento
  useEffect(() => {
    const scrollData = localStorage.getItem('scrollPublicacao');
    if (!scrollData) return;

    const { posicao, data, idpublicacaoOficial } = JSON.parse(scrollData);
    const now = new Date();
    const savedTime = new Date(data);
    const timeDifference = now.getTime() - savedTime.getTime();

    if (timeDifference > 600000) {
      localStorage.removeItem('scrollPublicacao');
      return;
    }

    let attempts = 0;
    const maxAttempts = 20;
    let isCancelled = false;

    const tryScrollToPublicacaoOficial = () => {
      if (isCancelled) return;

      const el = document.getElementById(idpublicacaoOficial);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        localStorage.removeItem('scrollPublicacao');
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryScrollToPublicacaoOficial, 300);
      } else {
        console.warn('Não foi possível encontrar o elemento da notícia para scroll.');
        localStorage.removeItem('scrollPublicacao');
      }
    };

    tryScrollToPublicacaoOficial();

    return () => {
      isCancelled = true;
    };
  }, [plublicacoesOficiais]);

  // Tela de carregamento inicial
  if (initialLoading && plublicacoesOficiais.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <PublicacaoOficialPublicListFiltroForm disabled={paramTipo ? true : false} paramTipo={paramTipo} handleBuscar={handleBuscar} />


{plublicacoesOficiais.length === 0 && !isFetching && (
        <Typography variant="h6" align="center" sx={{ mt: 4 }}>
          Nenhuma publicação oficial encontrada com os filtros aplicados.
        </Typography>
      )}



      {plublicacoesOficiais.map(n => (
        <PublicacaoOficialPublicCardForm key={n.id} publicacaoOficial={n} />
      ))}

      {isFetching && page > 1 && <CircularProgress sx={{ display: 'block', mx: 'auto', my: 3 }} />}

      <div ref={loaderRef} />
    </Box>
  );
}
